// 🔧 use_promotion_image.js
// ✅ Purpose: React hook for AI image generation in the LGV Promotion Engine
// ✅ Features:
// - Generates AI images
// - Refreshes AI images
// - Tracks loading state
// - Stores latest generated image
// - Stores latest generation error
// - Keeps React pages free from AI implementation details
// - Fully block-commented for clarity and future devs

import { useState } from "react";

import {
  generatePromotionImage,
} from "../services/promotion_image_service";

/**
 * ============================================================================
 * usePromotionImage
 * ============================================================================
 *
 * Central hook for AI image generation.
 */
export const usePromotionImage = () => {

  const [generatingImage, setGeneratingImage] =
    useState(false);

  const [imageResult, setImageResult] =
    useState(null);

  const [imageError, setImageError] =
    useState(null);

  /**
   * --------------------------------------------------------------------------
   * Generate Image
   * --------------------------------------------------------------------------
   */

  const generateImage = async (
    request
  ) => {

    setGeneratingImage(true);

    setImageError(null);

    try {

      const result =
        await generatePromotionImage(request);

      setImageResult(result);

      return result;

    } catch (error) {

      console.error(
        "[Promotion Image]",
        error
      );

      setImageError(error);

      throw error;

    } finally {

      setGeneratingImage(false);

    }

  };

  /**
   * --------------------------------------------------------------------------
   * Refresh Image
   * --------------------------------------------------------------------------
   *
   * Simply generates another image using the
   * same request.
   */

  const refreshImage = async (
    request
  ) => {

    return generateImage(request);

  };

  /**
   * --------------------------------------------------------------------------
   * Clear Image
   * --------------------------------------------------------------------------
   */

  const clearImage = () => {

    setImageResult(null);

    setImageError(null);

  };

  return {

    generatingImage,

    imageResult,

    imageError,

    generateImage,

    refreshImage,

    clearImage,

  };

};